import React from 'react';

import LoadingCompPropTypes from './LoadingCompPropTypes';

const LoadingComp = (props) => {
  if (props.isLoading) {
    return (
      <React.Fragment>
        <props.LoadingSpinner />
        {props.isHiddenWhileLoading ? null : props.children}
      </React.Fragment>
    );
  }

  return props.children;
};

LoadingComp.propTypes = LoadingCompPropTypes;

export default LoadingComp;
